import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Work from "./pages/Work";

const SITE_TITLE = "going plus – Global Strategy & Execution for Japanese Music & Entertainment";
const SITE_DESCRIPTION = "going plus is a Tokyo-based company specializing in global strategy, live touring, music, and entertainment execution for Japanese artists and IP.";

function SeoEnforcer() {
  const location = useLocation();
  useEffect(() => {
    // Force the canonical title on every route change — overrides any cached/legacy title.
    if (document.title !== SITE_TITLE) {
      document.title = SITE_TITLE;
    }
    // Ensure meta description stays correct
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    if (desc.getAttribute("content") !== SITE_DESCRIPTION) {
      desc.setAttribute("content", SITE_DESCRIPTION);
    }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SeoEnforcer />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/us" element={<AboutUs />} />
          <Route path="/work" element={<Work />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;